const colors = {
    hellesBlau: "#ADD8E6",
    pink: "#F991D3",
};

export default {
    hintergrund: colors.hellesBlau,
    śchlagSch: colors.pink
};